import axios from 'axios';
import { store } from '../store';
import { logoutAction } from '../store/modules/auth/actions';

store.subscribe(listener)

//const api = axios.create({ baseURL: 'http://127.0.0.1:8000/api' });
const api = axios.create({ baseURL: 'https://dashboard180.com/api' });
api.defaults.headers.post['Content-Type'] = 'application/json'

function listener() {
  //api.defaults.headers.common['Authorization'] = 'Bearer ' + store.getState().auth.token;
}

export default api;